import React from "react";
import "../index.scss";
import HorizontalCalendar from "../../../shared/horizontal-calendar";
import moment from "moment/moment";
import AvailableSeat from "../components/availableSeat";
import { COUNTER_TABLE, STANDARD_TABLE } from "../../../../constants/app";
import useBlockTime from "../../../../hooks/use-block-times";
import useCustomDiscountOptions from "../../../../hooks/use-custom-discount";
import { cloneDeep } from "lodash";
import styled from "styled-components";
import GourmetSelectMenu from "../components/gourmetSelectMenu";
// import { RequiredLabel } from "./common-styled";
import utils from "../../../../core/utils";
import LoginModal from "../components/loginModal";
import ConfirmBookingModal from "../components/confirmBookingModal";
import GourmetSelectBookingType from "../components/gourmetSelectBookingType";
import { HoverEffect } from "./common-styled";
import ViewDetailTable from "../components/viewDetailTable";

const DiscountWrapper = styled.div`
  font-size: 12px;
  max-width: 100px;
  text-align: center;
`;

const GourmetContainer = React.memo((props) => {
  const { shopDetail, userBookingData, shopMenus, shopDiscounts, userToken } =
    props.user;
  const {
    seats,
    table,
    chosenTime,
    total,
    discount,
    chosenMenu,
    selectedDate,
    otherDiscount,
    timeDiscount,
    special_menu,
    bookingType,
    isExtraSeat,
    isMultiTable,
    totalSeatsTable,
    childCount,
    adultCount,
  } = userBookingData;

  const formatSelectedDateObject = React.useMemo(() => {
    const { year, month, date } = selectedDate;
    if (!year || !month || !date) return null;
    return `${year}-${String(month).padStart(2, "0")}-${String(date).padStart(
      2,
      "0"
    )}`;
  }, [selectedDate.date, selectedDate.year, selectedDate.month]);

  const { __blockTimes } = useBlockTime(shopDetail, formatSelectedDateObject);
  const [availableSeats, setAvailableSeats] = React.useState([]);
  const [availableTables, setAvailableTables] = React.useState(null);
  const [isShowLoginModal, setIsShowLoginModal] = React.useState(false);
  const [isShowDetailTable, setIsShowDetailTable] = React.useState(false);
  const [isShowConfirmBookingModal, setIsShowConfirmBookingModal] =
    React.useState();
  const { listDiscount } = useCustomDiscountOptions({
    currentDate: formatSelectedDateObject,
  });

  const canGetTable = React.useMemo(() => {
    if (bookingType === COUNTER_TABLE) {
      return chosenTime && (chosenMenu || special_menu);
    }
    return !!seats && chosenTime && (chosenMenu || special_menu);
  }, [seats, chosenTime, chosenMenu, special_menu, bookingType]);

  React.useEffect(() => {
    if (timeDiscount && typeof timeDiscount === "object") {
      let timeD = 0;
      if (timeDiscount.type === "Other") {
        handleSaveDataToState({
          timeDiscount: timeDiscount.value_other,
        });
      } else {
        if (timeDiscount.type === "Fixed") {
          timeD = +timeDiscount.value;
        } else if (timeDiscount.type === "Percentage") {
          timeD = !total
            ? timeDiscount
            : (+timeDiscount.value * (+total - discount)) / 100;
        }
        handleSaveDataToState({
          timeDiscount: timeD,
        });
      }
    }
  }, [timeDiscount]);

  React.useEffect(() => {
    handleFetchAvailableSeat();
    if (chosenMenu) {
      const { other, totalDiscount } =
        handleInitDiscountWithBlockTime(chosenTime);
      handleSaveDataToState({
        discount: totalDiscount,
        otherDiscount: other,
      });
    }

    if (canGetTable) {
      handleFetchAvailableTable();
    }
    // handleSetBlockTime();
  }, []);

  React.useEffect(() => {
    if (availableTables?.length && bookingType === STANDARD_TABLE) {
      const chonsenTables =
        availableTables.filter((item) => table.includes(item.id)) || [];

      const totalSeats = chonsenTables.reduce(
        (sum, table) =>
          sum + (table.seats + (isExtraSeat ? table.extra_seats || 0 : 0)),
        0
      );

      handleSaveDataToState({
        totalSeatsTable: totalSeats,
      });
    }
  }, [table, availableTables, bookingType, isExtraSeat]);

  // React.useEffect(() => {
  //   if (selectedDate?.date && !table) {
  //     handleSetBlockTime();
  //   }
  // }, [selectedDate]);

  // React.useEffect(() => {
  //   if (seats) {
  //     handleFetchAvailableTable();
  //   }
  // }, [seats, selectedDate]);

  // React.useEffect(() => {
  //   if (chosenTime && listDiscountByTime) {
  //     const discountByTime = filterDiscountByTime(chosenTime);
  //     setListDiscountByTime(discountByTime);
  //   }
  // }, [chosenTime]);

  // React.useEffect(() => {
  //   if (table && availableTables?.length) {
  //     const times = availableTables.find(
  //       (item) => item.id === table
  //     )?.available_slots;

  //     const timeAvailable = times?.filter(
  //       (item) => item.status === AVAILABLE_SLOT
  //     );

  //     setBlockTimes(timeAvailable);
  //   }
  // }, [table, availableTables]);

  const handleInitDiscountWithBlockTime = React.useCallback(
    (defaultTime) => {
      if (chosenMenu) {
        const menuItem = shopMenus.find((menu) => +chosenMenu === menu.id);
        const discountItem = shopDiscounts.find(
          (item) => menuItem.discount === item.id
        );

        let totalDiscount = 0;
        let other = null;
        if (discountItem && isValidDiscount(discountItem, defaultTime)) {
          if (discountItem.type === "Percentage") {
            totalDiscount = (+discountItem.value * +total) / 100;
          } else if (discountItem.type === "Other") {
            other = discountItem;
          } else {
            totalDiscount = +discountItem.value;
          }
        }
        return { other, totalDiscount };
      }
    },
    [chosenMenu, chosenTime]
  );

  const isValidDiscount = React.useCallback(
    (discount, defaultTime) => {
      if (!discount || !discount.valid_from || !discount.valid_to) return false;

      const { year, month, date } = selectedDate;
      const selectTimeStr = `${year}-${month}-${date} ${defaultTime}`;
      const selectMoment = moment(selectTimeStr, "YYYY-MM-DD HH:mm");

      const validFrom = moment(discount.valid_from);
      const validTo = moment(discount.valid_to);

      const isDateInRange =
        selectMoment.isSameOrAfter(validFrom, "day") &&
        selectMoment.isSameOrBefore(validTo, "day");

      const isTimeInRange =
        selectMoment.format("HH:mm") >= validFrom.format("HH:mm") &&
        selectMoment.format("HH:mm") < validTo.format("HH:mm");

      return isDateInRange && isTimeInRange;
    },
    [selectedDate]
  );

  const canPay = React.useMemo(() => {
    const defaultActive =
      (chosenMenu || special_menu) &&
      chosenTime &&
      selectedDate?.date &&
      table?.length;
    if (bookingType === STANDARD_TABLE) {
      return childCount + adultCount === seats && defaultActive;
    }
    return defaultActive;
  }, [
    chosenMenu,
    chosenTime,
    selectedDate,
    special_menu,
    table,
    childCount,
    adultCount,
    seats,
  ]);

  const handleSaveDataToState = React.useCallback(
    (value) => {
      props.dispatchActions.setUserBookingData({
        key: shopDetail.id,
        value: {
          ...userBookingData,
          ...value,
        },
      });
    },
    [userBookingData]
  );

  const handleChangeDate = (date) => {
    const initData = getInitBookingFormData();
    handleSaveDataToState({
      ...initData,
      selectedDate: date,
    });
  };

  const getInitBookingFormData = () => {
    setAvailableTables(null);
    return {
      chosenMenu: "",
      total: "",
      discount: "",
      duration: "",
      chosenTime: "",
      isUserChosenTime: false,
      adultCount: 0,
      childAges: [],
      childCount: 0,
      note: "",
      phone: "",
      table: [],
      seats: "",
      timeDiscount: 0,
      percentDiscount: 0,
      totalSeatsTable: 0,
    };
  };

  const handleSetBookingType = (bookingType) => {
    const initData = getInitBookingFormData();
    const isStandardTable = bookingType === STANDARD_TABLE;
    let value = {
      ...initData,
      bookingType,
      isExtraSeat: isStandardTable,
      isMultiTable: isStandardTable,
    };
    handleSaveDataToState(value);
  };

  const handleFetchAvailableSeat = async () => {
    const result = await window.axios({
      url: `shop/${shopDetail.id}/guest-capacity/`,
      method: "get",
    });
    if (result.data.results) {
      const data = result.data.results.map((item) => item.capacity);
      setAvailableSeats(data);
    }
  };

  const handleFetchAvailableTable = async () => {
    const isStandardTable = bookingType === STANDARD_TABLE;
    const duration = getTotalDuration(chosenMenu?.split(","));
    let params = {
      accept_extra_seats: isExtraSeat,
      type: bookingType,
      date_time: formatSelectedDateObject + " " + chosenTime,
    };
    if (isStandardTable) {
      params.seats = seats;
    }

    if (duration && !special_menu) {
      params.duration = duration;
    } else {
      params.duration = shopDetail.stay_duration;
    }

    if (isExtraSeat) {
      params.accept_extra_seats = Number(isExtraSeat);
    }

    if (isMultiTable) {
      params.accept_multiple_tables = Number(isMultiTable);
    }

    const result = await window.axios({
      url: `shop/${shopDetail.id}/table/`,
      method: "get",
      params,
    });
    setAvailableTables(result.data.results);
  };

  const handleGetChooseOneTable = React.useCallback(
    (tableId) => {
      if (!table) return [tableId];

      const isExist = table.find((item) => Number(item) === Number(tableId));
      if (!isExist) {
        return [tableId];
      }
      return [];
    },
    [table]
  );

  const handleChooseMultiTable = React.useCallback(
    (tableId) => {
      let newTable = [];
      const tableClone = cloneDeep(table);
      if (!tableClone) {
        newTable = [tableId];
      } else {
        const index = tableClone.findIndex(
          (item) => Number(item) === Number(tableId)
        );
        const isTableIdExist = index >= 0;
        if (isTableIdExist) {
          tableClone.splice(index, 1);
          newTable = tableClone;
        } else {
          newTable = [...tableClone, tableId];
        }
      }
      return newTable;
    },
    [table, isMultiTable]
  );

  const handleTableSelected = (tableId) => {
    const table =
      isMultiTable || bookingType === COUNTER_TABLE
        ? handleChooseMultiTable(tableId)
        : handleGetChooseOneTable(tableId);
    handleSaveDataToState({
      table,
    });
  };

  const handleBlockTimeChange = (chosenTime, blockTimeDiscount) => {
    let discount;

    if (chosenMenu) {
      discount = handleInitDiscountWithBlockTime(chosenTime);
    }

    handleSaveDataToState({
      chosenTime,
      timeDiscount: blockTimeDiscount || null,
      otherDiscount: discount?.other || null,
      discount: discount?.totalDiscount || 0,
      table: [],
    });
  };

  const renderDiscountValue = (discount) => {
    if (discount.type === "Other") return discount.value_other;
    return `${discount.value?.split(".")?.[0]} ${
      discount.type === "Fixed" ? "円" : "%"
    }`;
  };

  // const renderDiscount = React.useCallback(
  //   (discount) => {
  //     if (!discount) return null;
  //     return (
  //       <DiscountWrapper className="d-flex align-items-center">
  //         <div className="me-1 text-truncate lh-lg">
  //           {renderDiscountValue(discount)}
  //         </div>
  //       </DiscountWrapper>
  //     );
  //   },
  //   [listDiscount]
  // );

  // const getDefaultDiscount = React.useCallback(
  //   (discount, time) => {
  //     if (!discount) return null;
  //     const data = discount.filter((item) => {
  //       const { start_block, end_block } = item;
  //       const format_valid_to = Number(end_block.replace(":", ""));
  //       const format_valid_from = Number(start_block.replace(":", ""));
  //       const format_time = Number(time.replace(":", ""));

  //       return (
  //         Number(format_valid_from) <= format_time &&
  //         Number(format_valid_to) > format_time
  //       );
  //     });

  //     return data.length ? data[0] : null;
  //   },
  //   [listDiscount]
  // );

  // const initDiscountData = React.useCallback(
  //   (ids) => {
  //     return listDiscount.filter((item) => ids.includes(item.id))?.[0];
  //   },
  //   [listDiscount]
  // );

  const renderDiscount = React.useCallback(
    (discount) => {
      if (!discount) return null;
      return (
        <DiscountWrapper className="d-flex align-items-center">
          <div className="me-1 text-truncate lh-lg">
            {renderDiscountValue(discount)}
          </div>
        </DiscountWrapper>
      );
    },
    [listDiscount]
  );

  const renderAvailableTable = () => {
    if (!shopDetail.show_tables || availableTables === null) return null;
    if (!availableTables?.length) {
      return seats ? (
        <div className="py-2">ご希望の人数に対応できる席がありません。</div>
      ) : null;
    }
    return (
      <div className="d-flex gap-2 pb-2 flex-wrap pt-4">
        {availableTables.map(({ id, name }) => {
          const isActive = Boolean(
            table?.length && table?.findIndex((tableId) => tableId === id) > -1
          );
          const isDisabled = seats <= totalSeatsTable;
          return (
            <div
              key={id}
              onClick={() => {
                if (isDisabled && !isActive) {
                  return;
                }
                handleTableSelected(id);
              }}
              className={`btn px-3 py-2 border ${
                isActive
                  ? "text-white"
                  : isDisabled
                  ? "text-muted"
                  : "btn-outline-secondary"
              }`}
              style={{
                backgroundColor: isActive
                  ? shopDetail.color
                  : isDisabled
                  ? "#f0f0f0"
                  : undefined,
                minWidth: "60px",
              }}
            >
              {name}
            </div>
          );
        })}
      </div>
    );
  };

  const getDefaultDiscount = React.useCallback(
    (discount, time) => {
      if (!discount) return null;
      const data = discount.filter((item) => {
        const { start_block, end_block } = item;
        const format_valid_to = Number(end_block.replace(":", ""));
        const format_valid_from = Number(start_block.replace(":", ""));
        const format_time = Number(time.replace(":", ""));

        return (
          Number(format_valid_from) <= format_time &&
          Number(format_valid_to) > format_time
        );
      });

      return data.length ? data[0] : null;
    },
    [listDiscount]
  );

  const renderBlockTimeList = React.useCallback(() => {
    if (!__blockTimes) return null;
    const { year, date, month } = selectedDate;
    return (
      <div className="mt-4">
        <div className="d-flex align-items-center mb-3">
          <span className="text-dark fw-bold me-2">時間</span>
        </div>
        <div className="d-flex gap-2 pb-2 flex-wrap">
          {__blockTimes.map((time) => {
            const value = time.start_time || time;
            const isPrevDate = moment(
              `${year}-${month}-${date} ${value}`,
              "YYYY-MM-DD HH:mm"
            ).isBefore(moment());
            const isActive = chosenTime === value;
            const discount = getDefaultDiscount(cloneDeep(listDiscount), value);
            return (
              <button
                key={value}
                // disabled={isPrevDate}
                onClick={() => handleBlockTimeChange(value, discount)}
                className={`btn btn-sm px-3 py-2 border ${
                  isActive ? "text-white border-0" : "btn-outline-secondary"
                }`}
                style={{
                  backgroundColor: isActive ? shopDetail.color : undefined,
                  minWidth: "60px",
                }}
                title=""
              >
                {value}
                {renderDiscount(discount)}
              </button>
            );
          })}
        </div>
      </div>
    );
  }, [listDiscount, chosenTime, __blockTimes, userBookingData, selectedDate]);

  const getTotalDuration = (menus) => {
    if (!menus?.length || special_menu) return 0;
    return menus
      .map((chosen) => shopMenus?.find((menu) => +chosen === menu.id))
      ?.reduce((acc, curr) => {
        return (acc += Number(curr?.duration));
      }, 0);
  };

  const getTotalDiscount = (menus) => {
    if (!menus.length) return 0;
    let totalDiscount = menus
      .map((chosen) => shopMenus?.find((menu) => +chosen === menu.id))
      ?.reduce((acc, curr) => {
        const discount = shopDiscounts.find(
          (item) => curr?.discount === item.id
        );

        let amount = acc;

        if (discount) {
          if (discount.type === "Percentage") {
            amount += (+discount.value * +curr?.price) / 100;
          } else {
            amount += +discount.value;
          }
        }
        return amount;
      }, 0);
    return totalDiscount;
  };

  const getTotalMoney = (menus) => {
    if (!menus.length) return 0;
    return menus
      .map((chosen) => shopMenus?.find((menu) => +chosen === menu.id))
      ?.reduce((acc, curr) => {
        return (acc += Number(curr.price));
      }, 0);
  };

  const onConfirmButtonClick = () => {
    if (!userToken) {
      setIsShowLoginModal(true);
      return;
    }
    setIsShowConfirmBookingModal(true);
  };

  const onCloseLoginModal = (data) => {
    setIsShowLoginModal(false);
    if (data && data.loginSuccess === true) {
      setIsShowConfirmBookingModal(true);
    }
  };

  const onCloseConfirmBookingModal = async (bookingId) => {
    setIsShowConfirmBookingModal(false);
    if (!bookingId) {
      return;
    }
    handleSaveDataToState({
      chosenMenu: "",
      total: "",
      discount: "",
      duration: "",
      chosenTime: "",
      isUserChosenTime: false,
      adultCount: 0,
      childAges: [],
      childCount: 0,
      note: "",
      phone: null,
      table: [],
      seats: [],
    });

    props.history.push(
      `/${shopDetail.id}/booking/${bookingId}/booking-success`
    );
  };

  const renderTotalMoney = () => {
    return (
      <div className="py-2">
        <div className="d-flex align-items-center justify-content-between">
          <div className="options__label fw-bold">金額:</div>
          <div className="text-danger">
            ¥ {utils.formatMoney(total || 0, 0, 3, ",", ".")}
          </div>
        </div>
      </div>
    );
  };

  const renderTotalDuration = () => {
    const duration = getTotalDuration(chosenMenu?.split(","));
    return (
      <div className="py-2">
        <div className="d-flex align-items-center justify-content-between">
          <div className="options__label fw-bold">時間: </div>
          <div>{duration || 0} 分</div>
        </div>
      </div>
    );
  };

  const renderTotalDiscount = () => {
    let totalDiscount = discount;
    let discountString = null;
    if (timeDiscount && typeof timeDiscount === "string") {
      discountString = <div>{timeDiscount}</div>;
    } else {
      totalDiscount = Number(discount || 0) + Number(timeDiscount || 0);
    }
    return (
      <div className="py-2">
        <div className="d-flex align-items-center justify-content-between">
          <div className="options__label fw-bold">割引:</div>
          <div className="text-end text-danger">
            {discountString}
            {otherDiscount && <div>{otherDiscount.value_other}</div>}
            <div className="mt-1">
              ¥ {utils.formatMoney(totalDiscount || 0, 0, 3, ",", ".")}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderLastPrice = () => {
    let totalDiscount = discount;
    if (timeDiscount && typeof timeDiscount === "number") {
      totalDiscount = Number(discount || 0) + Number(timeDiscount || 0);
    }
    return (
      <div className="py-2">
        <div className="d-flex align-items-center justify-content-between">
          <div className="options__label fw-bold">見積金額:</div>
          <div className="text-danger">
            ¥{" "}
            {total
              ? utils.formatMoney(total - totalDiscount, 0, 3, ",", ".")
              : 0}
          </div>
        </div>
      </div>
    );
  };

  const getTableCounterColor = (seat) => {
    const isAvailable = seat.status === "AVAILABLE";
    const isActive = Boolean(
      table?.length && table?.findIndex((tableId) => tableId === seat.id) > -1
    );
    let obj = {
      backgroundColor: "#fff",
      color: shopDetail.color,
    };

    if (!isAvailable) {
      obj.backgroundColor = "#f0f0f0";
      obj.color = "#888";
    } else if (isActive) {
      obj.backgroundColor = shopDetail.color;
      obj.color = "#888";
    }
    return obj;
  };

  const renderTableCounter = () => {
    if (!availableTables?.length) return null;
    return (
      <div className="pb-2 pt-4">
        {availableTables.map((table) => {
          if (!table.list_seats?.length) return null;
          return (
            <div
              key={table.id}
              className="d-flex align-items-center mb-2 p-2 rounded"
              style={{
                backgroundColor: "#FFEFD7",
              }}
            >
              <div className="me-2 text-truncate lh-lg flex-shrink-0">
                {table.name}
              </div>
              <div
                className="list-seats d-flex gap-1 overflow-x-auto"
                style={{
                  maxWidth: "100%",
                  overflowX: "auto",
                  whiteSpace: "nowrap",
                }}
              >
                {table.list_seats.map((seat) => {
                  const { backgroundColor, color } = getTableCounterColor(seat);
                  const isAvailable = seat.status === "AVAILABLE";
                  return (
                    <HoverEffect
                      $color={"#888"}
                      $bgColor={shopDetail.color}
                      $isActive={isAvailable}
                      key={seat.id}
                      className="seat-item p-3 btn"
                      onClick={() => {
                        if (isAvailable) {
                          handleTableSelected(seat.id);
                        }
                      }}
                      style={{
                        backgroundColor,
                        color,
                      }}
                    >
                      <div className="seat-item__name">{seat.seat_no}</div>
                    </HoverEffect>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div id="user-booking-home" className="user-home fade-out">
      <div className="user-home__wrapper bg-white">
        <p className="text-center font-bold pt-4 fw-bold fs-4">
          <i className="fas fa-solid fa-calendar me-1 fs-4"></i>予約
        </p>
        <div className="pb-4">
          <GourmetSelectBookingType
            pageColor={shopDetail.color}
            bookingType={bookingType}
            handleSetBookingType={handleSetBookingType}
          />
        </div>
        <div className="pb-4">
          <HorizontalCalendar
            shopId={shopDetail.id}
            onChange={handleChangeDate}
            selectedDate={selectedDate}
            pageColor={shopDetail.color}
            workingHoursOfWeek={shopDetail.workingHoursOfWeek}
          />
          <div className="mt-4 px-3">
            <GourmetSelectMenu
              {...props}
              pageColor={shopDetail.color}
              getTotalDiscount={getTotalDiscount}
              getTotalDuration={getTotalDuration}
              getTotalMoney={getTotalMoney}
            />
          </div>
          <div className="available-seats py-4 border-bottom">
            {bookingType === STANDARD_TABLE && (
              <AvailableSeat
                availableSeats={availableSeats}
                bookingType={bookingType}
                {...props}
                pageColor={shopDetail.color} // Orange color for gourmet booking
                onSeatSelect={(_) => {
                  setAvailableTables(null);
                }}
              />
            )}
            <div className="mt-4 px-3">{renderBlockTimeList()}</div>
            <div className="get-table text-center mt-3">
              <button
                className="btn py-2 px-3 mx-auto"
                disabled={!canGetTable}
                style={{
                  backgroundColor: shopDetail.color,
                }}
                onClick={handleFetchAvailableTable}
              >
                席を検索する
              </button>
            </div>
          </div>

          <div className="px-3">
            {bookingType === STANDARD_TABLE
              ? renderAvailableTable()
              : renderTableCounter()}
          </div>
          <div className="pt-4 px-3">
            <div className="border-bottom pb-2">
              <div>{renderTotalDuration()}</div>
              <div>{renderTotalMoney()}</div>
              <div>{renderTotalDiscount()}</div>
            </div>
          </div>

          <div className="__total pb-4 pt-2 px-3">
            <div>{renderLastPrice()}</div>
          </div>
          <div className="row justify-content-center px-3">
            {bookingType === STANDARD_TABLE && (
              <div className="mt-4 col-md-6 col-xs-12 px-3 ">
                <button
                  className="user-home__confirm-btn"
                  disabled={!table?.length}
                  style={{
                    backgroundColor: "#d6dbdf",
                    border: "none",
                    color: "#6c757d",
                  }}
                  onClick={() => {
                    setIsShowDetailTable(true);
                  }}
                >
                  テーブル詳細
                </button>
              </div>
            )}

            <div className="mt-4 col-md-6 col-xs-12 px-3 ">
              <button
                className="user-home__confirm-btn"
                style={{
                  backgroundColor: shopDetail.color,
                  border: "none",
                }}
                disabled={!canPay}
                onClick={onConfirmButtonClick}
              >
                確定
              </button>
            </div>
          </div>
        </div>
      </div>
      {isShowLoginModal && (
        <LoginModal onClose={onCloseLoginModal} {...props} />
      )}
      {isShowConfirmBookingModal && (
        <ConfirmBookingModal
          onClose={onCloseConfirmBookingModal}
          {...props}
          availableTable={availableTables}
        />
      )}

      {isShowDetailTable && (
        <ViewDetailTable
          onClose={() => {
            setIsShowDetailTable(false);
          }}
          table={table}
          listTable={availableTables}
          pageColor={shopDetail.color}
        />
      )}
    </div>
  );
});

export default GourmetContainer;
